import { ButtonView, ButtonViewDelegate, ToolbarView, ButtonClickEvent } from '@gaming/srvg-classes-core';

export interface OverlayButtonbarViewDelegate {
    handleButtonClickEvent( event: ButtonClickEvent, button: ButtonView );
}


export class OverlayButtonbarView extends ToolbarView implements ButtonViewDelegate {
    delegate: OverlayButtonbarViewDelegate;
    statisticsButton: ButtonView;
    tableButton: ButtonView;
    rosterButton: ButtonView;

    constructor( options ) {
        options = options || {};
        options.name = options.name || 'overlayButtonbarView';
        super( options );
        this.delegate = null;

        this.statisticsButton = this.addSubView( new ButtonView( { selector: '#statisticsButton' } ) );
        this.statisticsButton.setDelegate( this );
        this.tableButton = this.addSubView( new ButtonView( { selector: '#tableButton' } ) );
        this.tableButton.setDelegate( this );
        this.rosterButton = this.addSubView( new ButtonView( { selector: '#treeButton' } ) );
        this.rosterButton.setDelegate( this );

        this.generatedEvents.push( ButtonClickEvent );
    }

    handleButtonClickEvent( event: ButtonClickEvent, button: ButtonView ) {
        this.triggerEvent( event );
    }
}